import {connect} from 'react-redux';
import classNames from 'classnames';

import {Consumer} from '../TableWidthContext';

import Table from './Table';
import Fixed from './Fixed';
import Loading from './Loading';

const className = panelOpen => classNames('table-wrapper', {
    'panel-open': panelOpen,
});

const ForecastTable = ({parent, panelOpen}) => (
    <div id="forecast-table" className={className(panelOpen)}>
        <div className="table-inner">
            <Consumer>{onWidthChange => <Table onWidthChange={onWidthChange} />}</Consumer>
            <Fixed node={parent} panelOpen={panelOpen} />
            <Loading />
        </div>
    </div>
);

const mapStateToProps = ({panelOpen}) => ({
    panelOpen: panelOpen === 'config-header',
});

export default connect(mapStateToProps)(ForecastTable);
